/**
 * @file vehicle-info.service.ts
 * @module app/modules/orders-delivery/services/vehicle-info.service
 * @description Shared fetch helper for `routePlanning.vehicleInfo`. Consolidates the
 * duplicated APICallService construction for vehicle route/order info lookups across
 * goods-loading-details, review-orders-list, and route-details.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.1
 * @version 1.3.1
 */

import APICallService from '../../../../api/apiCallService';
import { routePlanning } from '../../../../api/apiEndPoints';

/**
 * Fetches vehicle route/order info for a given route id and vehicle id.
 * @param routeId Route plan identifier
 * @param vehicleId Vehicle reference
 * @param moduleName Permission module name
 * @param options Optional flags (e.g. { forLoading: true, forReview: true })
 * @param warehouseId Warehouse context
 */
export const fetchVehicleInfo = async (
  routeId: string,
  vehicleId: string,
  moduleName: any,
  options?: Record<string, any>,
  warehouseId?: string | null
) => {
  const params: any = options || {};
  if (warehouseId) {
    params.warehouse = warehouseId;
  }
  let apiService = new APICallService(
    routePlanning.vehicleInfo,
    params,
    { routeId, vehicleId },
    '',
    '',
    '',
    moduleName,
    warehouseId || null
  );
  return apiService.callAPI();
};
